import { Box, Heading, Text } from '@te-whatu-ora/anatomic'
import { Divider } from '@/components/accessibleDivider'

export default function SubmittedPage() {
  return (
    <>
      <Box paddingBottom='small'>
        <Heading level='2' as='h1' color='primary100'>
          Thank you
        </Heading>
        <Heading level='4' color='primary100'>
          We have received your submission.
        </Heading>
      </Box>
      <Box marginTop='small' marginBottom='medium'>
        <Divider variant='light' />
      </Box>
      <Box marginTop='small' marginBottom='medium'>
        <Text>You can now close this page.</Text>
      </Box>
    </>
  )
}
